//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import {useFormContext} from 'react-hook-form';

import ImageInput from './ImageInput';

import Toast from '../../../../../../../elements/Toast';
import {POPUP_BANNER_FIELDS, POPUP_LAYOUT_SIZE} from '../constants';

type Props = {
  classes?: {
    root?: string,
  },
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateRows: '1fr',
    width: '100%',
    gap: '1rem',
  },
}));

const RECOMMENDED_SIZE = {
  BELOW: {
    width: 1024,
    height: 800,
  },
  CENTER: {
    width: 825,
    height: 938,
  },
};

export default function PopupBannerImages(props: Props) {
  const classes = useStyles();

  const {setValue, errors, clearErrors, watch} = useFormContext();

  const imageError = !!errors[POPUP_BANNER_FIELDS.IMAGE];

  const image = watch(POPUP_BANNER_FIELDS.IMAGE);
  const layout = watch(POPUP_BANNER_FIELDS.CONTENT_POSITION);

  const propClasses = props.classes || {};

  const rootClasses = `${classes.root} ${
    propClasses.root ? propClasses.root : ''
  }`;

  const popupSize = RECOMMENDED_SIZE[layout];
  const aspectRatio = POPUP_LAYOUT_SIZE[layout].aspectRatio;

  return (
    <div className={rootClasses}>
      <ImageInput
        aspectRatio={aspectRatio}
        value={image}
        onChange={file => {
          setValue(POPUP_BANNER_FIELDS.IMAGE, file);
          clearErrors(POPUP_BANNER_FIELDS.IMAGE);
        }}
        error={imageError}
        label={`Sube una imagen (${popupSize.width} x ${popupSize.height})`}
      />
      <Toast
        open={!!imageError}
        onClose={() => {}}
        severity="error"
        closeDelay={5000}
      >
        Asegurese de subir una imagen para la versión desktop y mobile
      </Toast>
    </div>
  );
}
